import { render, staticRenderFns } from "./DappButtons.vue?vue&type=template&id=1c311444&scoped=true&"
import script from "./DappButtons.vue?vue&type=script&lang=js&"
export * from "./DappButtons.vue?vue&type=script&lang=js&"
import style0 from "./DappButtons.vue?vue&type=style&index=0&id=1c311444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c311444",
  null
  
)

export default component.exports